var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-activities-wrapper",
    },
    [
      _c("courseware-activities"),
      _vm._v(" "),
      _c(
        "MountingPortal",
        {
          attrs: {
            mountTo: "#courseware-activities-widget-filter-type",
            name: "sidebar-filter-type",
          },
        },
        [_c("courseware-activities-widget-filter-type")],
        1
      ),
      _vm._v(" "),
      _c(
        "MountingPortal",
        {
          attrs: {
            mountTo: "#courseware-activities-widget-filter-unit",
            name: "sidebar-filter-unit",
          },
        },
        [_c("courseware-activities-widget-filter-unit")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }